import { InjectionToken } from '@angular/core';
import { Locale } from '../enums/locale.enum';



export const DEFAULT_LANGUAGE = new InjectionToken<Locale>('portal-default-language', {
  factory: () => Locale.En,
});
